// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__emptyMiniCartBody__root","emptyTitle":"cmp-Minicart__emptyMiniCartBody__emptyTitle","continue":"cmp-Minicart__emptyMiniCartBody__continue"};